import { WHATSAPP_URL, IMAGES } from "../../constants/contact";

export function Hero() {
  return (
    <section data-testid="hero-section" className="py-20 md:py-28 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <span className="font-sans inline-block text-xs uppercase tracking-widest text-[#1B4D3E] font-bold border-b border-[#1B4D3E] pb-1 mb-6">
            Consulente Senior Indipendente · Italia
          </span>
          <h1 className="text-4xl md:text-6xl font-normal text-[#1B4D3E] leading-[1.08] mb-6" data-testid="hero-title">
            <span className="editorial-title-ln">
              <span>Basta costi occulti:</span>
            </span>
            <span className="editorial-title-ln">
              <span className="italic">semplifichiamo il POS.</span>
            </span>
          </h1>
          <p
            className="d2-fade font-sans text-base md:text-lg text-[#5A564F] leading-relaxed max-w-xl mb-8"
            data-testid="hero-subtitle"
          >
            Analisi gratuita dell'estratto conto e proposta chiara per abbattere le commissioni bancarie senza
            intermediari.
          </p>
          <div className="d2-fade flex flex-col sm:flex-row gap-4 font-sans text-xs font-bold tracking-wider uppercase">
            <a
              href="#contatto"
              data-testid="hero-cta-analisi"
              className="px-6 py-4 bg-[#1B4D3E] text-white text-center hover:bg-[#12352B] transition-colors"
            >
              Richiedi Analisi Senza Impegno
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="px-6 py-4 border border-[#1B4D3E] text-[#1B4D3E] text-center hover:bg-[#1B4D3E] hover:text-white transition-colors"
            >
              Contatta Alberto su WhatsApp
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="p-3 bg-white border border-[#E3DFD7] shadow-xl rotate-1 hover:rotate-0 transition-transform duration-500">
            <div className="w-full aspect-[4/5] relative frame-drift overflow-hidden">
              <img
                src={IMAGES.hero}
                alt="Terminale POS moderno sul bancone di un locale"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1C1B1A]/80 via-transparent to-transparent p-6 flex flex-col justify-end text-white">
                <span className="font-sans text-[10px] uppercase tracking-widest text-[#A3B18A]">
                  Assistenza Diretta
                </span>
                <p className="text-base italic mt-1">Parli direttamente con me, non con un centralino.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
